import * as yup from 'yup';
import { useI18n } from 'vue-i18n';

export function getRules() {
   const { t } = useI18n();

   return yup.object({
      contacts: yup.array().of(
         yup.object({
            name: yup
               .string()
               .trim()
               .min(1, t('live-editor.content-blocks.errors.required'))
               .max(255, t('live-editor.content-blocks.errors.max-length', { max: 255 }))
               .required(t('live-editor.content-blocks.errors.required')),
            email: yup.string().email(t('live-editor.content-blocks.errors.invalid-email')).nullable(),
         }),
      ),
   });
}
